import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import '@capacitor/core';
import { AppComponent } from 'src/app/app.component';
import { appConfig } from 'src/app/app.config';
import { environment } from 'src/environments/environment';
import { environments } from 'src/environments/environments';

if (environment.name === environments.production || environment.name === environments.staging) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  // eslint-disable-next-line no-console
  .catch(err => console.error(err));
